<template>
  <div class="cal_menu" :class="{ on: this.calmenu }" @click="Close">
    <div class="cal_inner">
      <div class="info_tit">
        <span class="cal_img01">
          <img
            v-if="GetMyInfo.photo !== undefined"
            :src="GetMyInfo.photo"
            alt=""
            @error="$event.target.src = '../../mobile/img/img03.png'"
          />
        </span>
        <dl>
          <dt>{{ GetMyInfo.info.name }} {{ GetMyInfo.info.position }}</dt>
          <dd>{{ GetMyInfo.info.dept }}</dd>
        </dl>
        <div>
          <!-- <span class="cal_sub_set"><a></a></span> -->
          <span class="cal_sub_close" @click="$emit('calMenuOff')"></span>
        </div>
      </div>
      <div class="cal_list">
        <li class="cal_type">
          <ul>
            <li class="month">
              <router-link :to="{ name: 'calmonth' }">{{
                lang.month
              }}</router-link>
            </li>
            <li class="week">
              <router-link :to="{ name: 'calweek' }">{{
                lang.week
              }}</router-link>
            </li>
            <li class="day">
              <router-link :to="{ name: 'calday' }">{{ lang.day }}</router-link>
            </li>
          </ul>
        </li>
        <li
          v-if="Config().company == 'ace'"
          class="my_cal"
          :class="{ on: this.myCal }"
        >
          <strong @click="toggle">일정위임자<em></em></strong>
          <ul>
            <!-- v-for="(value,index) in delegators" :key="index" -->
            <li
              class="impor_send"
              @click="pickgator(value)"
              v-for="(value, index) in delegators"
              :key="index"
            >
              <p>
                <span
                  class="impor_check"
                  :class="{
                    active: pickgators.includes(
                      value.entrydata[0].text[0].split('/')[1]
                    ),
                  }"
                ></span
                >{{ value.entrydata[0].text[0].split("/")[0] }}
              </p>
            </li>
          </ul>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  created() {
    this.lang = this.GetScheduleL.header;
    if (this.$route.query.empno) {
      this.pickgators = this.$route.query.empno.split(",");
      this.myCal = true;
    }
    if(this.Config().company=="ace"){
      this.$store
        .dispatch("calendarjs/CalGet", { type: "delegate" })
        .then((res) => {
          this.delegators = res;
        });
    }
  },
  props: ["calmenu"],
  computed: {
    ...mapGetters("mainjs", ["GetMyInfo"]),
  },
  data() {
    return {
      myCal: false,
      delegators: [],
      pickgators: [],
    };
  },
  methods: {
    Close(e) {
      var LayerPopup = $(".cal_menu");
      if (LayerPopup.has(e.target).length === 0) {
        this.$emit("calMenuOff");
      }
    },
    toggle() {
      this.myCal = !this.myCal;
    },
    pickgator(value) {
      var empno = value.entrydata[0].text[0].split("/")[1];
      if (this.pickgators.includes(empno)) {
        this.pickgators = this.pickgators.filter((item) => {
          return item !== empno;
        });
      } else {
        this.pickgators.push(empno);
      }
      if (this.pickgators.length > 0) {

        this.$router.push({
          name: "calmonth",
          query: { empno: this.pickgators.join(",") },
        });
      }
    },
  },
};
</script>

<style>
</style>